<!-- Page Wrapper -->
<div class="page_wrapper">
    <div class="full_bg">
        <section class="signup_section">
            <div class="container">

                <!-- Top Navigation -->
                <div class="top_part">
                    <!-- <a (click)="goToHome()" class="back_btn" style="cursor: pointer;">
                        <i class="fa fa-arrow-left"></i> Back to home
                    </a> -->
                    <a class="navbar-brand" (click)="goToHome()" style="cursor: pointer;">
                        <img src="assets/images/auth/logo.png" alt="ShiftClock Logo">
                    </a>
                </div>

                <!-- Sign In Form Block -->
                <div class="form_block">

                    <!-- Left Side: Content Image -->
                    <div class="side_screen">
                        <div class="section_title">
                            <h2>Login to Access Your ShiftClock Account</h2>
                            <p>Securely sign in to manage schedules, track hours, and stay on top of your team's shifts anytime, anywhere.</p>
                        </div>

                        <div class="scrren">
                            <img src="assets/images/auth/sign-up-img.png" alt="Sign In Illustration">
                        </div>
                    </div>

                    <!-- Right Side: Form -->
                    <div class="form_side">
                        <div class="section_title">
                            <span class="title_badge">Welcome Back</span>
                            <h4><span>Sign in</span> to your account</h4>
                            <p>Quickly access your features.</p>
                        </div>

                        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

                            <!-- Username Input -->
                            <div class="form-group">
                                <input type="text" formControlName="username" class="form-control" placeholder="Username or Email" [class.is-invalid]="f['username'].invalid && f['username'].touched">
                            </div>

                            <!-- Password Input -->
                            <div class="form-group">
                                <input type="password" formControlName="password" class="form-control" placeholder="Password" [class.is-invalid]="f['password'].invalid && f['password'].touched">
                            </div>

                            <!-- Captcha -->
                            <div class="form-group mb-3">
                                <label id="captchaLabel">{{ captchaQuestion }}</label>
                                <input type="text" formControlName="captchaInput" class="form-control" placeholder="Answer" [class.is-invalid]="f['captchaInput'].invalid && f['captchaInput'].touched">
                            </div>

                            <!-- Remember Me & Forgot Password -->
                            <div class="forgate_check">
                                <div class="coustome_checkbox">
                                    <label for="rememberMe">
                    <input 
                      type="checkbox" 
                      id="rememberMe" 
                      formControlName="rememberMe">
                    <span class="checkmark"></span>
                    Remember me
                  </label>
                                </div>
                                <a (click)="goToForgotPassword()" style="cursor: pointer;">Forgot password?</a>
                            </div>

                            <!-- Submit Button -->
                            <div class="btn_block">
                                <button type="submit" class="puprple_btn" [disabled]="isLoading">
                  {{ isLoading ? 'Signing In...' : 'Sign In' }}
                </button>
                                <div class="btn_bottom"></div>
                            </div>

                            <!-- Sign Up Link -->
                            <!-- <div class="sign_in_here">
                                <p>Don't have an account? <a (click)="goToSignUp()" style="cursor: pointer;">Sign Up here</a></p>
                            </div> -->

                            <!-- Error Message -->
                            <div *ngIf="errorMessage" class="error text-danger mt-2">
                                {{ errorMessage }}
                            </div>

                        </form>
                    </div>

                </div>

            </div>
        </section>
    </div>
</div>